import type { GameMeta } from "../../common/gameMeta.js";
import type { ColorCodeVariantConfig } from "./variantConfig.js";

export const meta = {
	name: "Color Code",
	minPlayers: 1,
	maxPlayers: 8,
	description: "Crack the secret color sequence before your opponents do.",
	instructions: `
The host has hidden a secret sequence of 4 colored pegs.
Each round, arrange your 4-peg guess and submit before the timer runs out.
After everyone submits, you'll see your feedback:
● = right color, right position  ○ = right color, wrong position
Fewest rounds to crack the code wins!
	`.trim(),
	mobileBrowserCompatible: true,
	showScores: false,
	modifiers: [
		{
			id: "hard",
			label: "Hard Mode",
			instructions: "6 colors in the palette, and partial-match hints are hidden.",
			config: { paletteSize: 6, noDuplicateHint: true } satisfies ColorCodeVariantConfig,
		},
	],
} satisfies GameMeta;
